import { Activity, AlertTriangle, Award, Bell, DollarSign, GitHub, Headphones, Heart, Link2, Mail, Music, Settings } from "react-feather";
import { CardSubtitle } from "../../types/CoreComponents";
import { BadgeTagPill } from "../../types/UiKits";

export const BadgesContextualSubTitle: CardSubtitle[] = [
  {
    text: "Use the",
    code: ".badge ",
  },
  {
    text: "class to make more badges.",
  },
];

export const PillsContextualSubTitle: CardSubtitle[] = [
  {
    text: "Use the",
    code: ".rounded-pill ",
  },
  {
    text: "utility class to make badges more rounded with a larger ",
    code: "border-radius",
  },
  {
    text: ".",
  },
];

export const NumberPillsSubTitle: CardSubtitle[] = [
  {
    text: "Use the",
    code: ".rounded-circle ",
  },
  {
    text: "utility class to make badges more rounded with a larger ",
    code: "border-radius",
  },
  {
    text: ".",
  },
];

export const PillsIconSubTitle: CardSubtitle[] = [
  {
    text: "Use ",
    code: ".rounded-circle",
  },
  {
    text: "utility class to make badges more rounded with a larger ",
    code: "border-radius",
  },
  {
    text: ".",
  },
];

export const BadgeWithIconSubTitle: CardSubtitle[] = [
  {
    text: "Use the",
    code: ".badge ",
  },
  {
    text: "utility class to make more icons.",
  },
];

export const NumberBadgeSubTitle: CardSubtitle[] = [
  {
    text: "Use the",
    code: ".badge ",
  },
  {
    text: "utility class to make number of more badges.",
  },
];

export const BadgeIconSubTitle: CardSubtitle[] = [
  {
    text: "Use the ",
    code: ".badge ",
  },
  {
    text: "utility class to make more icons.",
  },
];

export const RoundedPillSubTitle: CardSubtitle[] = [
  {
    text: "Use the",
    code: ".rounded-pill",
  },
  {
    text: " utility class to make icons badges more rounded with a larger ",
    code: "border-radius",
  },
  {
    text: ".",
  },
];

export const BadgeHeadingSubTitle: CardSubtitle[] = [
  {
    text: "All html headings,",
    code: " <h1> ",
  },
  {
    text: "through",
    code: " <h6> ",
  },
  {
    text: ", are available in",
    code: " .badge ",
  },
  {
    text: "tags.",
  },
];

export const BadgeButtonSubTitle: CardSubtitle[] = [
  {
    text: "",
    code: ".badge",
  },
  {
    text: " can be used as part of ",
    code: ".btn",
  },
  {
    text: " to provide a icons.",
  },
];

export const BadgesData: BadgeTagPill[] = [
  {
    id: 1,
    color: "primary",
    text: "Primary",
  },
  {
    id: 2,
    color: "secondary",
    text: "Secondary",
  },
  {
    id: 3,
    color: "success",
    text: "Success",
  },
  {
    id: 4,
    color: "info",
    text: "Info",
  },
  {
    id: 5,
    color: "warning",
    text: "Warning",
  },
  {
    id: 6,
    color: "danger",
    text: "Danger",
  },
  {
    id: 7,
    color: "light text-dark",
    text: "Light",
  },
  {
    id: 8,
    color: "dark",
    text: "Dark",
  },
];

export const BadgeIconData: BadgeTagPill[] = [
  {
    id: 1,
    color: "primary",
    iconName: <DollarSign />,
  },
  {
    id: 2,
    color: "secondary",
    iconName: <Headphones />,
  },
  {
    id: 3,
    color: "success",
    iconName: <Link2 />,
  },
  {
    id: 4,
    color: "info",
    iconName: <GitHub />,
  },
  {
    id: 5,
    color: "warning",
    iconName: <Award />,
  },
  {
    id: 6,
    color: "danger",
    iconName: <Activity />,
  },
  {
    id: 7,
    color: "light text-dark",
    iconName: <Heart />,
  },
  {
    id: 8,
    color: "dark",
    iconName: <Mail />,
  },
];

export const BadgeButtonData: BadgeTagPill[] = [
  {
    id: 1,
    class: "primary",
    text: "Messages",
    iconName: <Mail />,
  },
  {
    id: 2,
    class: "secondary",
    text: "notifications",
    iconName: <Bell />,
  },
  {
    id: 3,
    class: "success",
    text: "Update available",
    iconName: <Settings />,
  },
  {
    id: 4,
    class: "info",
    text: "Playing Now",
    iconName: <Music />,
  },
  {
    id: 5,
    class: "warning",
    text: "1.2 GB Used",
    iconName: <AlertTriangle />,
  },
];
